import { motion } from 'motion/react'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import ActionButton from '../ActionButton'
import BlockTitle from '../BlockTitle'
import FigureCard from '../FigureCard'
import Picture from '../Picture'
import RichText from '../RichText'
import Slider from '../Slider'

export const Container = styled.section`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  &:not(:first-child) {
    margin-block-start: var(--g_spacing__blocks);
  }
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(142)};
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(56)};
  @media ${mq(sizes.desktop)} {
    gap: ${pxToRem(16)};
  }
`

export const _BlockTitle = styled(BlockTitle)`
  max-width: calc(100% - ${pxToRem(16)} * 2);
  margin-inline: auto;
  @media ${mq(sizes.desktop)} {
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Secondary = styled(motion.div)`
  display: flex;
  width: 100%;
  margin-inline: auto;
  flex-flow: column;
  gap: ${pxToRem(32)};
  max-width: calc(100% - ${pxToRem(16)} * 2);

  @media ${mq(sizes.desktop)} {
    flex-flow: row-reverse;
    gap: ${pxToRem(56)};
    max-width: calc(100% - ${pxToRem(32)} * 2);
  }
`

export const Content = styled(motion.div)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  align-self: flex-start;
  @media ${mq(sizes.big)} {
    position: sticky;
    inset-block-start: var(--g_height__header);
    padding-block: ${pxToRem(40)};
  }
`
export const Subtitle = styled.p`
  ${({ theme }) => theme.textStyles.m375_h3}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h2}
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_body}
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
  }
`
export const _ActionButton = styled(ActionButton)`
  display: none;
  @media ${mq(sizes.desktop)} {
    display: flex;
    align-self: flex-start;
    &:not(:first-child) {
      margin-block-start: ${pxToRem(8)};
    }
  }
`
export const _Picture = styled(motion.create(Picture))`
  @media ${mq(sizes.desktop)} {
    flex: 0 0 auto;
    width: calc(1 / 2 * 100%);
  }
  @media ${mq(sizes.big)} {
    width: calc(
      2 / 3 * 100% - ${pxToRem(6)}
    ); // magical value, should be 16 / 2 instead of 6
  }
`

export const SliderWrapper = styled(motion.div)`
  padding-inline: ${pxToRem(16)};
  @media ${mq(sizes.desktop)} {
    padding-inline: ${pxToRem(32)};
  }
`

export const _Slider = styled(Slider)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(32)};
  overflow: hidden;
  & .keen-slider[data-keen-slider-disabled],
  & .keen-slider:not([data-keen-slider-disabled]) {
    padding-block: 1px;
    overflow: visible;
  }
  & .keen-slider__slide {
    display: flex;
  }
  @media ${mq(sizes.desktop)} {
    & .keen-slider[data-keen-slider-disabled] {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-template-rows: auto;
      gap: ${pxToRem(16)};
    }
    // nested 💩 but more readable with than without
    // - 4 items
    & .keen-slider:has(.keen-slider__slide:nth-child(4):last-child) {
      & :nth-child(3) {
        grid-row: 2;
        grid-column: 2;
      }
      & :nth-child(4) {
        grid-row: 2;
        grid-column: 3;
      }
    }
    // - 5 items / 6 items
    & .keen-slider:has(.keen-slider__slide:nth-child(5):last-child),
    & .keen-slider:has(.keen-slider__slide:nth-child(6):last-child) {
      & :nth-child(4) {
        grid-column: 2;
      }
      & :nth-child(5) {
        grid-column: 3;
      }
      & :nth-child(6) {
        grid-row: 3;
        grid-column: 3;
      }
    }
  }
`
export const _FigureCard = styled(motion.create(FigureCard)).withConfig({
  shouldForwardProp: () => true,
})<{
  complementsHeight?: number
}>`
  flex: 1;
`
